import CustomersList from './CustomersList';
import InsurersList from './InsurersList';
import SuppliersList from './SuppliersList';

interface Props {
  handleSelect: (name: string, id: number) => void;
  type: string;
}
function SearchList({ handleSelect, type }: Props) {
  if (type === 'Cliente') {
    return <CustomersList handleSelect={handleSelect} />;
  }

  if (type === 'Fornecedor') {
    return <SuppliersList handleSelect={handleSelect} />;
  }

  if (type === 'Seguradora') {
    return <InsurersList handleSelect={handleSelect} />;
  }

  return null;
}

export default SearchList;
